const FormatCurrency = {
  install(Vue) {
    Vue.filter('FormatCurrency', (data) => {
      if (data) {
        return new Intl.NumberFormat('pt-BR', {
          format: 'currency',
          currency: 'BRL',
          minimumFractionDigits: 2,
        }).format(data);
      }
      return 'N/I';
    });
  },
};

export default FormatCurrency;
